'use client';

import {NotFound} from 'app/components/pages/NotFound';

export default function Error({
  error,
  reset,
}: {
  error: Error & {digest?: string};
  reset: () => void;
}) {
  return <NotFound error={error} reset={reset} />;
}
